<ng-container>
    <a class="{{ buttonClass }}" *ngIf="tooltipText" ycnTooltip [tooltipTitle]="tooltipText"
       [ngClass]="{'dropdown-toggle': showDropdownCaret}"
       href="javascript:void(0)"
       ycnDisabled [disabled]="inputDisabled"
       (click)="toggleOpen()">
            <svg *ngIf="config.title.icon" [class]="config.title.iconClass"  ycnIcon [name]="config.title.icon"></svg>
            <span *ngIf="config.title.label" [textContent]="config.title.icon ? config.title.label : config.title.label">
            </span>
    </a>
    <a class="{{ buttonClass }}" *ngIf="!tooltipText"
       [ngClass]="{'dropdown-toggle': showDropdownCaret}"
       href="javascript:void(0)"
       ycnDisabled [disabled]="inputDisabled"
       (click)="toggleOpen()">
            <svg *ngIf="config.title.icon" [class]="config.title.iconClass"  ycnIcon [name]="config.title.icon"></svg>
            <span *ngIf="config.title.label" [textContent]="config.title.icon ? config.title.label : config.title.label">
            </span>
    </a>
    <div [ycnAppendToBody]="appendToBody" #dropdownMenu class="dropdown-menu {{ dropdownClass }}" [ngClass]="{show: isOpen}">
        <span *ngFor="let listItem of config.list" [ngSwitch]="listItem.type">
            <div class="dropdown-divider" *ngSwitchCase="'divider'"></div>
            <a class="dropdown-item {{ listItem.dropdownItemClass }}"
               href="javascript:void(0)"
               *ngSwitchCase="'option'"
               [attr.data-test-id]="'dropdown-option-' + listItem.value"
               ycnDisabled [disabled]="listItem.disabled"
               (click)="submit(listItem)">
                <svg *ngIf="!!listItem.icon" ycnIcon [name]="listItem.icon"></svg>
                <span class="dropdown-item-text">
                    <span
                         [ngClass]="{'dropdown-item-text-with-new': config.hasNew}"
                         [textContent]="listItem.label">
                    </span>
                    <ng-container *ngIf="listItem.helpName">
                        <span>&nbsp;</span>
                        <span class="help-toggler" (click)="helpModal.openModal(listItem.helpName); $event.stopPropagation()">(?)</span>
                    </ng-container>
                </span>
                <svg *ngIf="!!listItem.isNew" ycnIcon [name]="'icon-new'"></svg>
            </a>
            </span>
    </div>
</ng-container>
<ycn-help-modal #helpModal></ycn-help-modal>
